import React from 'react'
import classNames from 'classnames'

export default function ModalBody({ children, className = '', style = {} }) {
  return (
    <div
      className={classNames(
        'padding-vertical-larger padding-horizontal-largest background-shade-100 radius-normal',
        className
      )}
      style={style}
    >
      {children}
    </div>
  )
}
